import { render, staticRenderFns } from "./ListModels.vue?vue&type=template&id=2befee52"
import script from "./ListModels.vue?vue&type=script&lang=js"
export * from "./ListModels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports